import { render } from "./HelpWellnessDialog.vue?vue&type=template&id=5047e72e"
import script from "./HelpWellnessDialog.vue?vue&type=script&lang=js"
export * from "./HelpWellnessDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__